/**
* `result` shows action results and hides them after a while
*
*
* ## usage
* ```html
* <result [status]="status" ></result>
* ```
*/
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResultComponentDef } from '@df/ui/api/result.component.def';
@Component({
    selector: 'result',
    templateUrl: './result.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass]
})
export class ResultComponent extends ResultComponentDef {
}
